angular.module('iqxCore')
    .service('TerminologySvc', function
        (ApplicationSvc, ApiSvc, $http) {
        var svc = this
        var fetchScope = {}
        var combinedTerminology = {}
        var defaultTerminology = {}

        function _getDefaultTerminology () {  // Return a promise. Set defaultTerminology to the fetch result if it doesn't already exist.
            return new Promise ( function ( resolve, reject ) {
                if ( Object.keys ( defaultTerminology ).length === 0 ){
                    ApiSvc.fetch(fetchScope, {
                        fetchAPI: 'terminology/terminology',
                        fetchTarget: 'defaultTerminology',
                        multiRow: false,
                        notLoggedIn: true
                    }).then(function () {
                        defaultTerminology = fetchScope.defaultTerminology
                        resolve ( defaultTerminology )
                    })
                } else {
                    resolve ( defaultTerminology )
                }
            })
        }

        function _getOverrideTerminology ( divID ) { // Return a promise. Set overrideTerminology to fetch result if it doesn't already exist.
            return new Promise ( function ( resolve, reject ) {
                ApiSvc.fetch(fetchScope, {
                    fetchAPI: `callresult${ApplicationSvc.isLoggedIn ? '' : '_'}/NetLanguageOverride${divID}`,
                    fetchTarget: 'overrideTerminology',
                    multiRow: true,
                    booleanFields: [],
                    notLoggedIn: true // http default headers set but applicationSvc isLoggedIn still false, so need this but procedure still authenticated (dont add to unauthenticated list).  
                }).then(function () {
                    combinedTerminology = defaultTerminology
                    fetchScope.overrideTerminology.forEach( function( t ) {
                        combinedTerminology[t.TerminologyID] = t.OverrideValue
                    })
                    resolve ( combinedTerminology )
                })
            })
        }

        function _divID(divisionID) { // Get the user's divisionid if it exists
            if(divisionID) {
                return '?pDivisionID=' + divisionID
            }
            if (ApplicationSvc.currentUser.registrationDetails) { // Candidate
                return '?pDivisionID=' + ApplicationSvc.currentUser.registrationDetails.DivisionID
            } else if (ApplicationSvc.currentUser.divisionid) { // client
                return '?pDivisionID=' + ApplicationSvc.currentUser.divisionid
            } else { // everyone else?
                return ''
            }
        }


        function _getTerminologyObject (divisionID) {  // Returns a promise. Resolve the default promise, then if override doesn't exist divid exists get the override terminology. Resolve either way so you're not left hanging.
            return new Promise (function(resolve, reject){
                if ( Object.keys ( combinedTerminology ).length != 0 ) {
                    resolve ( combinedTerminology )
                }
                _getDefaultTerminology ( ).then ( function ( defaultTerminologyObject ) {
                    var divID = _divID(divisionID ? divisionID : null)
                    if ( Object.keys ( defaultTerminologyObject ).length != 0 && divID != '' ) {
                        _getOverrideTerminology ( divID ).then ( function ( combinedTerminologyObject ) {
                            resolve ( combinedTerminologyObject )
                        } )
                    } else {
                        resolve ( defaultTerminologyObject )
                    }
                })
            })
        }

        svc.getTerminology = function (keys = [], divisionID) { // To be called by controllers. Will check to see if any terminology needs to be fetched, then for each ID that was given (or all if none were given), it will return the terminology value. Catches errors too like an absolute legend.
            return new Promise ( function ( resolve, reject ){
                _getTerminologyObject(divisionID).then ( function ( terminologyObject ) {
                    var terms = { }
                    if ( keys.length == 0 ) {
                        resolve ( terminologyObject )
                    }
                    try {
                        keys.forEach ( function ( key ) {
                            terms [ key ] = terminologyObject [ key ]
                        } )
                        resolve ( terms )
                    } catch ( error ) {
                        reject ( "Something went wrong with the terminology service." )
                    }
                })
            })
        }
    })